import { createClient } from '@supabase/supabase-js';

// Direct Supabase client. The anon key is safe to expose in the frontend
// (RLS policies enforce per-user data isolation), but it is loaded from
// Vite environment variables so it stays out of source control.
//
// Set these in a .env.local file (or your hosting platform's env config):
//   VITE_SUPABASE_URL=https://<project>.supabase.co
//   VITE_SUPABASE_ANON_KEY=<your-anon-key>
const SUPABASE_URL = 'https://yjzkknurgpwefmsjhpyx.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlqemtrbnVyZ3B3ZWZtc2pocHl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU4NTkwNTYsImV4cCI6MjEwMTQzNTA1Nn0.f69H8EAWT3Et-doNZ-vbhQUx1NV3UE1OpQR57h7El8g';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});